import { useGradeSelectorSelector } from "../redux/hooks";
import { selectModel } from "../redux/slices/GradeSelectorModelSlice";
import type { PromotionType } from "./types/Model";

export const usePromotions = (ids?: string[]): PromotionType[] => {
    const { promotions } = useGradeSelectorSelector(selectModel);
    const filteredPromotions = promotions.filter(({ disclaimer }) => disclaimer !== null);

    if (ids) {
        return filteredPromotions.filter(({ id }) => ids.includes(id));
    }

    return filteredPromotions;
};
